import { useEffect, useMemo, useState } from 'react';
import moment from 'moment';
import { Meeting as MeetingApi } from 'api';
import { AllMeetingStatus, MeetingRecord } from 'type/meeting';
import { getDisplayConflictRecords, resolvePagedDisplayConflicts } from '../../utils/conflict';

/** 保留 store 中的原始冲突标记，只调整日程卡片展示。 */
export const useDisplayConflictRecords = (records: MeetingRecord[], isDayView: boolean) => {
  const [resolved, setResolved] = useState<{ source: MeetingRecord[]; records: MeetingRecord[] } | null>(null);
  const displayRecords = useMemo(() => {
    // 分页补查完成前只隐藏请假、拒绝自身的提示，不根据不完整列表清除其他会议的冲突。
    const result = getDisplayConflictRecords(records, isDayView ? records : []);
    if (!isDayView) return result;
    const now = Date.now();
    return result.map((record) => {
      const { meeting } = record;
      const ended = meeting.status === AllMeetingStatus.FINISH || meeting.status === AllMeetingStatus.FILED || now >= meeting.endTime;
      return ended && record.conflict ? { ...record, conflict: 0 } : record;
    });
  }, [records, isDayView]);

  useEffect(() => {
    if (isDayView) return;
    let active = true;
    resolvePagedDisplayConflicts(records, async (range) => {
      try {
        const response = await MeetingApi.getMeetingByUserId({
          beginTime: moment(range.beginTime).startOf('day').valueOf(),
          endTime: moment(range.endTime).endOf('day').valueOf(),
          markConflict: false
        }).toPromise();
        return response?.data;
      } catch {
        return undefined;
      }
    }).then((result) => {
      if (active) setResolved({ source: records, records: result });
    });
    return () => { active = false; };
  }, [records, isDayView]);

  return !isDayView && resolved?.source === records ? resolved.records : displayRecords;
};
